/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable arrow-parens */
/* eslint-disable no-console */
const toDataURL = (fileData: string, type: string) => {
    if (!fileData) return null;

    // Base64 -> バイナリ
    const binary = window.atob(fileData);

    // バイナリ -> Uint8Array
    const buffer = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        buffer[i] = binary.charCodeAt(i);
    }

    // Uint8Array -> Blob
    const blob = new Blob([buffer.buffer], { type });

    // Blob -> Data URL
    return window.URL.createObjectURL(blob);
};

const revokeDataURL = (dataURL: string) => window.URL.revokeObjectURL(dataURL);

const getBody = () => document.querySelector("body")!;

const generateAnchor = (fileName: string, dataURL: string) => {
    const anchor = document.createElement("a");
    anchor.href = dataURL;
    anchor.download = fileName;

    const body = getBody();
    body.appendChild(anchor);

    return anchor;
};

const removeAnchor = (anchor: HTMLAnchorElement) => {
    const body = getBody();
    body.removeChild(anchor);
};

/**
 * ファイルのダウンロード
 *
 * @param fileName ダウンロード時のファイル名
 * @param fileData ファイル内容のBase64文字列
 * @param contentType ファイルのMIMEタイプ
 */
export const downloadFile = (fileName: string, fileData: string, contentType: string) => {
    if (!fileData) return;

    // Base64 -> Data URL
    const dataURL = toDataURL(fileData, contentType);
    if (!dataURL) return;

    // aタグ生成
    const anchor = generateAnchor(fileName, dataURL);

    // ダウンロード
    anchor.click();

    // aタグ除去
    removeAnchor(anchor);

    // Data URL解放
    revokeDataURL(dataURL);
};
